<template>
  <a-layout-header :class="headerCls" >
    <!-- logo -->
    <div class="head-logo">
      <svg-icon iconfont name="open-icon-a-Artboard6beifen" v-if="/^\/company\/helper\/center/.test($route.path)"></svg-icon>
      <svg-icon iconfont name="open-icon-yicangxinlogo" v-else></svg-icon>
    </div>
    <!-- menu -->
    <ul class="head-menu">
      <li v-if="!$WMSEnvFlag" class="head-menu__item" :class="$route.path === '/home' ? 'active' : ''" @click="$router.push('/home')">
        <svg-icon iconfont name="open-icon-daohang-shouye1" class="menu-icon"></svg-icon>
        <span>{{$t('common_menu_home')}}</span>
      </li>
      <li class="head-menu__item" :class="/^\/work/.test($route.path) ? 'active' : ''" @click="toWrok">
        <svg-icon iconfont name="open-icon-gongzuotai" class="menu-icon"></svg-icon>
        <span>{{$t('common_menu_workbench')}}</span>
      </li>
      <li v-if="!$WMSEnvFlag" class="head-menu__item" :class="['/documentCenter', '/sachDoc'].includes($route.path) ? 'active' : ''" @click="$router.push('/docCenter')">
        <svg-icon iconfont name="open-icon-wendang1" class="menu-icon"></svg-icon>
        <span>{{$t('common_menu_document')}}</span>
      </li>
      <li v-if="!$WMSEnvFlag" class="head-menu__item" @click="tobuy">
        <svg-icon iconfont name="open-icon-shangdaohang-daohang-goumai1" class="menu-icon" ></svg-icon>
        <span>{{$t('common_menu_buy')}}</span>
      </li>
    </ul>
    <!-- language | avatar -->
    <div class="head-opt">
      <select-lang></select-lang>
      <head-company-show v-if="hideInfo.userId" />
      <div class="header-login" v-else>
        <span @click="toGin('login')">{{$t('common_login')}}</span>
        <span @click="toGin('register')">{{$t('common_login_register')}}</span>
      </div>
    </div>

    <!-- modal -->
    <information-up />
    <switch-company v-if="hideInfo.userId" ref="switchCompany"></switch-company>
    <Login-tips v-if="isTips" />
  </a-layout-header>
</template>
<script>
import { TransformLogin } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import HeadCompanyShow from './HeadCompanyShow.vue'
import SelectLang from './SelectLang.vue'
import { mapGetters } from 'vuex'

import LoginTips from '@/views/Login'
import informationUp from '@/components/informationUp'
import SwitchCompany from '@/components/SwitchCompany'

export default {
  name: 'GlobalHeader',
  components: {
    HeadCompanyShow,
    SelectLang,
     'Login-tips': LoginTips,
    informationUp,
    SwitchCompany
  },
  props: {
    ghost: Number
  },
  data () {
    return {
      isShow: true,
      systemCode: 'ERP'
    }
  },
  computed: {
    headerCls () {
      const ghost = ['/home', '/documentCenter', '/seachDoc'].includes(this.$route.path)
      return ghost ? 'ghost' : ''
    },
    ...mapGetters([
      'hideInfo',
      'isTips'
    ])
  },
  methods: {
    toGin (type) {
      this.$store.commit('ON_LOGIN', type)
      this.$store.commit('IS_CALLME', false)
    },
    tobuy () {
      if (this.$ls.get(ACCESS_TOKEN)) {
        TransformLogin({
          targetPlatformCode: 'SSO_SYS_USER'
        }).then(res => {
          window.open(`${process.env.VUE_APP_HOME_URL || '//testnew-home.eccang.com'}/#/company/serve/buy-serve?token=${res.data}`, '_blank')
        })
      } else {
        this.$store.commit('SET_ISBUY', true)
        this.toGin('login')
      }
    },
    /**
     * 跳转工作台
     */
    toWrok () {
      if (this.$ls.get(ACCESS_TOKEN)) {
        console.log('this.$store.state.isLogin.meunList', this.$store.state.isLogin.meunList)
        if (this.$store.state.isLogin.meunList && this.$store.state.isLogin.meunList.length) {
          const menuList = this.$store.state.isLogin.meunList
          this.handleToPath(menuList)
        } else {
          this.$router.push('/work/credentials')
        }
      } else {
        this.toGin('login')
      }
    },
    /**
     * 路由跳转
    */
    handleToPath (menuList) {
      const type = menuList[0].menuName
      switch (type) {
        case '资质管理':
          return this.$router.push('/work/credentials')
        case '应用管理':
          return this.$router.push('/work/applied')
        case '接口日志':
          return this.$router.push('/work/interDiary')
        case 'API列表':
          return this.$router.push('/work/apiApi')
        default:
          return this.$router.push('/work/childAct')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ant-layout-header {
  line-height: 1;
}

// 透明样式
.ghost {
  background: rgba(0, 0, 0, 0.16);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 100;
}
// 正常样式
header {
  padding: 0px;
  color: #fff;
  display: flex;
  justify-content: flex-start;
  text-align: left;
  background: linear-gradient(270deg, #0356F2 0%, #077BFC 100%);
}
.head-logo {
  width: 200px;
  overflow: hidden;
  padding-left: 17px;
  .icon-svg {
    font-size: 126px;
    top: -30px;
    position: relative;
  }
}
.head-menu {
  display: flex;
  height: 64px;
  &__item {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #ffffff;
    padding: 0 25px;
    &:active, &.active, &:hover {
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
    }
  }
  .menu-icon {
    font-size: 18px;
    margin-right: 5px;
  }
}

.head-opt {
  margin-left: auto;
  color: #fff;
  display: flex;

  .header-login {
    display: inline-flex;
    align-items: center;
    text-align: center;
    cursor: pointer;
    padding: 0 20px;
    margin-right: 10px;
    /deep/.login-text {
      color: #fff;
    }
    span {
      &:nth-child(1) {
        display: inline-block;
        width:80px;
        height:30px;
        line-height: 31px;
        background:rgba(73,120,214,1);
        border-radius:17px;
        margin-right: 22px;
      }
    }
  }
}
</style>
